<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">PREFACE</p>
<p class="noindent">I have always enjoyed travel by train. Whenever I need to go into downtown Chicago, my first inclination is to catch the South Shore line in Northwest Indiana and travel in comfort (now that smoking is not allowed on the cars) and not worry about traffic jams.</p>
<p class="indent">The first long-distance railroad trip I remember was back in December 1967, my senior year of college, when my two brothers and I took the train from Chicago to Los Angeles in order to go to the Rose Bowl game. In later years, my wife and I have traveled by train to various places, one being to the Henry Ford Museum/Greenfield Village at Dearborn, Michigan. Those trips and others in between allowed us to see American scenery unavailable to passengers on aircraft but did not give us the experience of traveling during railroad’s golden age until the year 2016, when we took a trip that included a train ride from San Francisco to Portland on reconditioned Pullman cars. We slept in a Pullman sleeper and spent the day in a domed/dining car. Riding through the Cascade Mountains with the view from and the comfort of that car was spectacular. Our service mirrored what one might have expected in the 1920s: linen tablecloths, a fresh rose, fine food, attentive service. It was a once-in-a-lifetime experience that we’d like to do again.</p>
<p class="indent">So, when two years later I was asked to write a small book for the new Pullman National Monument, I was intrigued and delighted. That small book, available at the gift shop on the Pullman grounds, was too small to contain all I wanted to include. Thus this book. The National Monument has much to offer. Enjoy the trip.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?0e9937ee